module.exports = __webpack_public_path__ + "static/media/ngir_logo.fbd17b82.svg";